// lib

import PropTypes from 'prop-types'

// styles
import style from '@aytm/app/stats/page/sidebar/target/styles/TargetPanel.module.scss'

const TargetListSurvey = ({ model }) => (
  <>
    <div className={style.section}>
      <div className={style['section-title']}>Survey Completion Time</div>

      <div className={style.section}>
        <div className={style.row}>
          <span className={`${style.column} ${style['column-label']}`}>Shortest:</span>
          <div className={`${style.column} ${style['column-values']}`}>{model.completion_times.shortest}</div>
        </div>
        <div className={style.row}>
          <span className={`${style.column} ${style['column-label']}`}>Median:</span>
          <div className={`${style.column} ${style['column-values']}`}>{model.completion_times.median}</div>
        </div>
        <div className={style.row}>
          <span className={`${style.column} ${style['column-label']}`}>Mean:</span>
          <div className={`${style.column} ${style['column-values']}`}>{model.completion_times.mean}</div>
        </div>
        <div className={style.row}>
          <span className={`${style.column} ${style['column-label']}`}>Longest:</span>
          <div className={`${style.column} ${style['column-values']}`}>{model.completion_times.longest}</div>
        </div>
      </div>
    </div>

    <div className={style.section}>
      <div className={style['section-title']}>Survey Completion Info</div>

      <div className={style.section}>
        <div className={style.row}>
          <span className={`${style.column} ${style['column-label']}`}>Survey completes:</span>
          <div className={`${style.column} ${style['column-values']}`}>
            {model.totalRespondents} <span>(including EXITS by skip logic)</span>
          </div>
        </div>
        <div className={style.row}>
          <span className={`${style.column} ${style['column-label']}`}>Partial completes:</span>
          <div className={`${style.column} ${style['column-values']}`}>
            {model.totalPartialResponses} <span>(in process / abandoned)</span>
          </div>
        </div>
        <div className={style.row}>
          <span className={`${style.column} ${style['column-label']}`}>Failed prequalification:</span>
          <div className={`${style.column} ${style['column-values']}`}>{model.totalFailedPrequalsResponses}</div>
        </div>
        <div className={style.row}>
          <span className={`${style.column} ${style['column-label']}`}>Rejected:</span>
          <div className={`${style.column} ${style['column-values']}`}>{model.totalOeRejectedResponses}</div>
        </div>
      </div>
    </div>
  </>
)

TargetListSurvey.propTypes = {
  model: PropTypes.object
}

TargetListSurvey.displayName = 'TargetListSurvey'

export default TargetListSurvey
